import angular from 'angular';
import { CookiesService } from './service/CookiesService.js';
import { cookieSettingsComponent } from './settings/cookieSettingsComponent';

angular
	.module('sh.cookies', [])
	.service('Cookies', CookiesService)
	.component('shCookiesSettings', cookieSettingsComponent());
